import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';

import {
	adminAuthenticationImpersonatedUserTokenReducers,
	adminAuthenticationImpersonatedUserTokenWatchers
} from './impersonated-user-tokens';
import {
	adminAuthenticationImpersonateStopReducers,
	adminAuthenticationImpersonateStopWatchers
} from './impersonate-stop';

export const adminAuthenticationReducers = combineReducers({
	impersonateStop: adminAuthenticationImpersonateStopReducers,
	impersonatedUserTokens: adminAuthenticationImpersonatedUserTokenReducers
});

export const adminAuthenticationWatchers = combineAllWatchers([
	adminAuthenticationImpersonateStopWatchers,
	adminAuthenticationImpersonatedUserTokenWatchers
]);
